module.exports = __webpack_public_path__ + "img/product-chuti-qt-01.24fb8a95.png";